import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios'
import i18n from 'i18next'
import UserService from './UserService'
import { environment } from '../../enviroments/enviroment'

const axiosInstance = axios.create({
  baseURL: environment.baseUrl,
})

axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const token = await getTokenAndCheckExpiration()
  const headers = new AxiosHeaders(config.headers)

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  headers.set('Accept-Language', i18n.language)

  const method = (config.method || 'get').toLowerCase()
  if (!headers.has('Content-Type') && (method === 'post' || method === 'put' || method === 'patch')) {
    headers.set('Content-Type', 'application/json')
  }

  config.headers = headers
  return config
})

const getTokenAndCheckExpiration = async () => {
  if (UserService.isTokenExpired()) {
    await UserService.updateToken(() => {})
  }
  return UserService.getToken()
}

export default axiosInstance
